import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "mb-0 mt-2 text-sm leading-tight text-gray-500" }
const _hoisted_2 = { class: "grid grid-cols-[minmax(0,1fr)_82px_104px] items-end gap-3 border-b-2 border-gray-400 pb-2 text-sm sm:grid-cols-[minmax(0,1fr)_104px_120px] sm:gap-4" }
const _hoisted_3 = { class: "text-right" }
const _hoisted_4 = { class: "text-xs text-black" }
const _hoisted_5 = { class: "text-right" }
const _hoisted_6 = { class: "text-xs text-black" }
const _hoisted_7 = {
  key: 0,
  class: "space-y-4 py-6"
}
const _hoisted_8 = {
  key: 1,
  class: "py-10 text-center text-sm text-gray-500"
}
const _hoisted_9 = {
  key: 2,
  class: "divide-y divide-gray-100"
}
const _hoisted_10 = { class: "grid grid-cols-[minmax(0,1fr)_82px_104px] items-center gap-3 sm:grid-cols-[minmax(0,1fr)_104px_120px] sm:gap-4" }
const _hoisted_11 = { class: "min-w-0 flex items-center gap-3" }
const _hoisted_12 = { class: "min-w-0" }
const _hoisted_13 = { class: "truncate text-sm font-medium text-black" }
const _hoisted_14 = { class: "truncate text-xs text-gray-500" }
const _hoisted_15 = { class: "text-right text-sm font-medium text-black" }
const _hoisted_16 = { class: "text-right text-sm font-medium text-black" }
const _hoisted_17 = { class: "mt-3 h-1.5 overflow-hidden rounded-full bg-gray-100" }

import { computed } from 'vue'
import type { AcheteurRow } from '@/types'


export default /*@__PURE__*/_defineComponent({
  __name: 'BuyerSalesStatsSection',
  props: {
    rows: { default: () => [] },
    loading: { type: Boolean, default: false },
    periodLabel: {},
    frameless: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props

const parseAmount = (value: number | string) => {
  if (typeof value === 'number') return value
  const normalized = String(value || '0')
    .replace(/\s/g, '')
    .replace('€', '')
    .replace(',', '.')
  return Number.parseFloat(normalized) || 0
}

const totalOrders = computed(() =>
  props.rows.reduce((total, row) => total + Number(row.commandes || 0), 0),
)

const totalAmount = computed(() =>
  props.rows.reduce((total, row) => total + parseAmount(row.montant), 0),
)

const maxAmount = computed(() =>
  Math.max(1, ...props.rows.map((row) => parseAmount(row.montant))),
)

const formatCurrency = (value: number) =>
  `${value.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`

const getWidth = (amount: number | string) =>
  Math.max(3, Math.round((parseAmount(amount) / maxAmount.value) * 100))

const getInitials = (name: string) => {
  const words = (name || '?')
    .trim()
    .split(/\s+/)
    .filter(Boolean)
  const initials = words.slice(0, 2).map((word) => word.charAt(0)).join('')
  return initials.toUpperCase() || '?'
}

const getBuyerLabel = (orders: number) =>
  `${orders} ${orders > 1 ? 'commandes' : 'commande'}`

const getAvatarColor = (id: number) => {
  const colors = ['#e0f2fe', '#dcfce7', '#fef3c7', '#ede9fe', '#fee2e2']
  return colors[Math.abs(Number(id || 0)) % colors.length]
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass([
      props.frameless
        ? 'bg-transparent overflow-hidden'
        : 'bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden'
    ])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(props.frameless ? 'pt-1 pb-2' : 'px-6 pt-5 pb-4 border-b border-gray-200')
    }, [
      _createElementVNode("div", null, [
        _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "mb-0 text-xl font-semibold leading-tight text-black" }, "Meilleurs acheteurs", -1)),
        _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.periodLabel), 1)
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(props.frameless ? 'pt-3 pb-5' : 'px-6 py-5')
    }, [
      _createElementVNode("div", _hoisted_2, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "font-medium text-black" }, "Acheteurs", -1)),
        _createElementVNode("div", _hoisted_3, [
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "font-medium text-black" }, "Commandes", -1)),
          _createElementVNode("div", _hoisted_4, _toDisplayString(totalOrders.value), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "font-medium text-black" }, "Montant (HT)", -1)),
          _createElementVNode("div", _hoisted_6, _toDisplayString(formatCurrency(totalAmount.value)), 1)
        ])
      ]),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (index) => {
              return _createElementVNode("div", {
                key: index,
                class: "animate-pulse"
              }, _cache[4] || (_cache[4] = [
                _createStaticVNode("<div class=\"grid grid-cols-[minmax(0,1fr)_82px_104px] items-center gap-3 sm:grid-cols-[minmax(0,1fr)_104px_120px] sm:gap-4\"><div class=\"flex items-center gap-3\"><div class=\"h-9 w-9 rounded bg-gray-200\"></div><div class=\"h-3 w-2/3 rounded bg-gray-200\"></div></div><div class=\"ml-auto h-3 w-10 rounded bg-gray-200\"></div><div class=\"ml-auto h-3 w-16 rounded bg-gray-200\"></div></div><div class=\"mt-3 h-1 rounded bg-gray-100\"></div>", 2)
              ]))
            }), 64))
          ]))
        : (_ctx.rows.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, " Aucun acheteur sur cette période. "))
          : (_openBlock(), _createElementBlock("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row) => {
                return (_openBlock(), _createElementBlock("article", {
                  key: row.id,
                  class: "py-4"
                }, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", {
                        class: "flex h-9 w-9 shrink-0 items-center justify-center rounded bg-slate-100 text-xs font-semibold text-slate-700 ring-1 ring-slate-200",
                        style: _normalizeStyle({ backgroundColor: getAvatarColor(row.id) })
                      }, _toDisplayString(getInitials(row.nom)), 5),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, _toDisplayString(row.nom), 1),
                        _createElementVNode("div", _hoisted_14, _toDisplayString(getBuyerLabel(row.commandes)), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_15, _toDisplayString(row.commandes), 1),
                    _createElementVNode("div", _hoisted_16, _toDisplayString(row.montant), 1)
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", {
                      class: "h-full rounded-full bg-blue-700",
                      style: _normalizeStyle({ width: `${getWidth(row.montant)}%` })
                    }, null, 4)
                  ])
                ]))
              }), 128))
            ]))
    ], 2)
  ], 2))
}
}

})